// Shared chrome for artifact renderers: the framed figure every kind sits in,
// plus the download/copy plumbing.

import { useState } from "react";

export function ArtifactFrame({
  title,
  kindLabel,
  children,
  rightSlot,
}: {
  title?: string;
  kindLabel: string;
  children: React.ReactNode;
  rightSlot?: React.ReactNode;
}) {
  return (
    <figure className="panel-atelier overflow-hidden">
      <figcaption className="flex items-baseline justify-between gap-3 border-b border-ruleline px-5 py-2.5">
        <span className="flex items-baseline gap-3">
          <span className="label-mono">{kindLabel}</span>
          {title ? (
            <span className="font-serif italic text-warmgray-500">{title}</span>
          ) : null}
        </span>
        {rightSlot}
      </figcaption>
      <div className="overflow-x-auto px-5 py-4">{children}</div>
    </figure>
  );
}

export function CopyButton({ getText, label = "copy" }: { getText: () => string; label?: string }) {
  const [copied, setCopied] = useState(false);
  return (
    <button
      type="button"
      onClick={async () => {
        try {
          await navigator.clipboard.writeText(getText());
          setCopied(true);
          window.setTimeout(() => setCopied(false), 1500);
        } catch {
          /* clipboard unavailable; fail silently */
        }
      }}
      className="font-mono text-[0.7rem] tracking-normal normal-case text-oxblood-500 hover:text-oxblood-600"
    >
      {copied ? "copied ✓" : `${label} ⌘C`}
    </button>
  );
}
